import React from "react";
import LinkBtn from "../shared/LinkBtn";
import FooterIcons from "../footer/FooterIcons";
import MentorsityLinks from "../footer/MentorsityLinks";
import SupportLinks from "../footer/SupportLinks";
import "./Footer.scss";
import footerLogo from "../../assets/footer-logo.png";
import DynamicLinks from "../footer/DynamicLinks";
import CopyRight from "../footer/CopyRight";

export default function Footer() {
  return (
    <footer className="footer-container relative">
      {/* Enhanced Curved Top Shape */}
      <div className="absolute top-0 left-0 right-0">
        <div className="h-12 bg-white rounded-b-[100%] transform -translate-y-6"></div>
      </div>
      
      <div className="footer-content">
        {/* Main Footer Section */}
        <div className="flex flex-col md:flex-row w-full gap-6 md:gap-10">
          {/* Left Section: Logo and Social Icons */}
          <div className="flex-1">
            <div className="footer-logo-cont">
              <div className="flex justify-start w-full pl-0 md:pl-1">
                <img
                  src={footerLogo}
                  alt="mentorsity-logo"
                  className="footer-logo"
                />
              </div>
            </div>
            <div className="mt-4">
              <p className="font-medium mb-2">Follow us!</p>
              <FooterIcons />
            </div>
          </div>

          {/* Center Section: Links */}
          <div className="flex-1 flex flex-col md:flex-row gap-8 justify-center">
            <MentorsityLinks />
            <SupportLinks />
          </div>

          {/* Right Section: Buttons */}
          <div className="flex-1 flex flex-col items-start md:items-end gap-4">
            <LinkBtn goto="/contact-us" className="footer-button contact w-36 h-10 text-base">
              Contact
            </LinkBtn>
            <LinkBtn goto="#" className="footer-button learn-more w-36 h-10 text-base">
              Learn More
            </LinkBtn>
          </div>
        </div>

        {/* Horizontal Border Line */}
        <div className="border-t border-gray-300 opacity-50 w-full my-6"></div>

        {/* Programs Section */}
        <div className="my-6">
          <div className="w-full">
            <DynamicLinks />
          </div>
        </div>

        {/* Horizontal Border Line */}
        <div className="border-t border-gray-300 opacity-50 w-full my-6"></div>

        {/* Copyright Section */}
        <div className="w-full py-4 flex justify-center">
          <CopyRight />
        </div>
      </div>
    </footer>
  );
}
